import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { Button, IconButton, Tooltip, Typography } from "@material-ui/core";
import { Check, Clear } from "@material-ui/icons";

/** スタイル定義 */
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tr: {
      width: "100%",
      border: "1px solid rgb(224,224,224)",
      borderLeft: "none",
      borderRight: "none",
      borderBottom: "none",
    },
    tdFile: {
      width: "100%",
      padding: theme.spacing(2),
    },
    form: {
      display: "flex",
      width: "100%",
    },
    fileContainer: {
      display: "flex",
      alignItems: "center",
      width: "100%",
    },
    text: {
      marginLeft: theme.spacing(1),
      width: "80%",
      fontSize: "0.875rem",
      cursor: "pointer",
    },
    iconButton: {
      color: theme.palette.text.primary,
    },
    iconFile: {
      position: "relative",
      top: "-4px",
    },
    iconButtonFile: {
      width: "2.4rem",
      height: "2.4rem",
    },
  })
);

interface Props {
  // キー
  dictKey: string;
  // データ
  file?: File | null;
  inputRef: React.RefObject<HTMLInputElement>;
  onChangeFile: (file: File | null) => void;
  // アクション
  onApproved: () => any;
  onCanceled: () => any;
}

/** 辞書設定テーブル編集行 */
export function DictionaryConfigRowEdit(props: Props) {
  const classes = useStyles();

  const {
    // キー
    dictKey,
    // データ
    file,
    inputRef,
    onChangeFile,
    // アクション
    onApproved,
    onCanceled,
  } = props;

  //--------------------
  // コンポーネント
  return (
    <tr className={classes.tr}>
      <td className={classes.tdFile} colSpan={2}>
        <div className={classes.form}>
          <div className={classes.fileContainer}>
            <Button
              variant="contained"
              size="small"
              component="label"
              htmlFor={`id_file_${dictKey}`}
            >
              ファイル選択
            </Button>
            <Typography
              component="span"
              className={classes.text}
              onClick={() => {
                if (inputRef.current) {
                  inputRef.current.click();
                }
              }}
            >
              {/* [HP稼働]: electronからの修正 */}
              {/* {file ? file.path : "選択されていません"} */}
            </Typography>

            {/* 非表示, 非制御インプット */}
            <input
              id={`id_file_${dictKey}`}
              name="file"
              type="file"
              onChange={() => {
                if (inputRef.current) {
                  if (inputRef.current.files) {
                    // ファイルが設定された場合
                    if (inputRef.current.files[0]) {
                      // const file = inputRef.current.files[0];
                      // setFileData({ file });
                      onChangeFile(inputRef.current.files[0]);
                    }
                  }
                }
              }}
              ref={inputRef}
              style={{ display: "none" }}
            />
          </div>
        </div>
      </td>
      <td>
        <div>
          {/* 保存 */}
          <Tooltip title="保存">
            <span>
              {/*
                ボタンが非活性になるとTooltipが表示できなくなるためspanで囲む必要がある
                Tooltip --- Disabled Elements
                https://material-ui.com/components/tooltips/#disabled-elements
              */}
              <IconButton
                className={classes.iconButton}
                onClick={onApproved}
                disabled={!file}
              >
                <Check />
              </IconButton>
            </span>
          </Tooltip>
          {/* キャンセル */}
          <Tooltip title="キャンセル">
            <IconButton
              className={classes.iconButton}
              onClick={() => {
                // Fileデータをクリアする
                onChangeFile(null);
                // キャンセルイベントを実行する
                onCanceled();
              }}
            >
              <Clear />
            </IconButton>
          </Tooltip>
        </div>
      </td>
    </tr>
  );
}
